import React from "react";
import { Button, Box } from "@mui/material";
import { useHistory } from "react-router-dom";

import { mstrPath } from "../../utils/mstrBase";
function NavigationMenuItem(props) {
  const { text, pageName, imageName, sx } = props;
  const history = useHistory();

  return (
    <Button
      color="primary"
      sx={sx}
      variant="contained"
      onClick={(x) => {
        history.push(mstrPath(pageName));
      }}
    >
      <Box sx={{ width: "100%" }}>
        <img
          alt={pageName}
          className="landing-icon-image"
          src={mstrPath(`images/${imageName}.svg`)}
        />
        {text}
      </Box>
    </Button>
  );
}
export default NavigationMenuItem;
